export * from './cetres.component';